import React from "react";

const Card = ({ data }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
      {data.map((item, i) => (
        <div
          key={i}
          className="border border-white/20 hover:border-white/60 bg-white/5 hover:bg-white/10 rounded-[20px] p-6 transition-all duration-300 group cursor-default"
        >
          <div className="bg-btnColor w-14 h-14 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
            <img src={item.icon} alt={item.title} className="w-7 h-7 object-contain" />
          </div>
          <p className="font-popinsSemiBold text-lg text-white leading-snug mb-3">
            {item.title}
          </p>
          <p className="text-white/70 font-popinsRegular text-sm leading-relaxed">
            {item.desc}
          </p>
        </div>
      ))}
    </div>
  );
};

export default Card;
